export default __webpack_public_path__ + "static/media/download.01e36326.svg";